import React from 'react';
import {
    CardNumberElement, CardCVCElement, CardExpiryElement, PostalCodeElement, injectStripe
} from 'react-stripe-elements';
import {
    Dialog, DialogActions, DialogContent, Button, CircularProgress
} from "@material-ui/core";
import { Close } from '@material-ui/icons'
import {withStyles} from "@material-ui/core";
import APIService from '../apis/amplify/APIService'
import DialogTitleContainer, { Title, TitleButton } from "../components/DialogTitleContainer";
import ErrorMessage from "../components/ErrorMessage";
import If from "../components/If";

class CreditCardDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            saving: false,
            addDialogOpen: false,
            stripeValidationError: null,
        };
        this.submit = this.submit.bind(this);
    }

    async submit(ev) {
        this.setState({ saving: true });
        ev.preventDefault();
        try {
            let {token, error} = await this.props.stripe.createToken({name: "Name"});
            if (error) {
                const {message} = error;
                this.setState({stripeValidationError: message});
            } else {
                const response = await APIService.registerPaymentCard(token.id);
                this.props.onCardAdded();
                this.setState({stripeValidationError: null});
                if (this.props.selectCard) {
                    this.props.selectCard(response.id)
                }
                this.props.onBackdropClick();
            }
        }
        catch (e) {
            console.error(e);
        } finally {
            this.setState({ saving: false });
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ addDialogOpen: nextProps.open })
    }

    render() {
        const { classes, onBackdropClick } = this.props;
        const {stripeValidationError} = this.state;
        return (
            <Dialog open={this.state.addDialogOpen} fullWidth disableBackdropClick={false}
                    onBackdropClick={onBackdropClick}>
                <DialogTitleContainer>
                    <Title>NEW CREDIT CARD</Title>
                    <TitleButton className="closeButton" location="right"
                                 onClick={onBackdropClick}>
                        <Close/>
                    </TitleButton>
                </DialogTitleContainer>
                <DialogContent>
                    <div className={classes.container}>
                        <div>
                            <span className="label">Card number*</span>
                            <CardNumberElement className="input"/>
                        </div>
                        <div>
                            <span className="label">Expiration date*</span>
                            <CardExpiryElement className="input"/>
                        </div>
                        <div>
                            <span className="label">Postal code*</span>
                            <PostalCodeElement className="input"/>
                        </div>
                        <div>
                            <span className="label">CVV*</span>
                            <CardCVCElement className="input"/>
                        </div>
                        <If condition={!!stripeValidationError}>
                            <ErrorMessage>{stripeValidationError}</ErrorMessage>
                        </If>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.submit}
                            disabled={this.state.saving}
                            fullWidth variant="contained" color="secondary">
                        ADD CARD<CircularProgress size={20} id='progress'
                                                  style={{ display: this.state.saving === true ? 'block' : 'none' }}/>
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = () => ({
    container: {
        padding: '12px 20px',
        '& .label': {
            fontSize: 12,
            color: '#616161'
        },
        '& .input': {
            borderBottom: '1px solid #616161',
            marginBottom: 20,
            padding: '5px 0',
        },
        '& .input:focus': {
            borderBottom: '2px solid #616161',
        }
    },
});


export default injectStripe(withStyles(styles)(CreditCardDialog));
